import React from 'react';
import Loading from 'components/Loading';
import NotFound from 'components/Errors/NotFound';
import { useHistoricalGetOrgChartHr } from 'routes/HumanResourcesModule/helpers/hooks/orgChartHr';
import {
    EtablissementAndPayBudgetContext,
    OrgChartHrContext,
} from 'routes/HumanResourcesModule/components/contexts/HumanResourcesContext';
import {
    useGetPayBudget,
    useGetEtablissements,
} from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationModal/components/hooks/optionalArguments';

type Props = {
    children?: React.ReactNode;
};

const HumanResourcesProvider = ({
    children = <></>,
}: Props): React.ReactElement => {
    const {
        data: historicalOrgChartHrData,
        isLoading: isLoadingHistoricalOrgChartHr,
        isError: isHistoricalOrgChartHrError,
    } = useHistoricalGetOrgChartHr();
    const { data: payBudgetData, isLoading: isPayBudgetDataLoading } =
        useGetPayBudget();
    const { data: etablissementsData, isLoading: isEtablissementDataLoading } =
        useGetEtablissements();

    if (
        isLoadingHistoricalOrgChartHr ||
        isPayBudgetDataLoading ||
        isEtablissementDataLoading
    ) {
        return (
            <div className="page-container">
                <Loading />
            </div>
        );
    }

    if (isHistoricalOrgChartHrError || historicalOrgChartHrData === undefined) {
        return <NotFound />;
    }

    return (
        <OrgChartHrContext.Provider value={historicalOrgChartHrData}>
            <EtablissementAndPayBudgetContext.Provider
                value={{
                    payBudget: payBudgetData || [],
                    etablissement: etablissementsData || [],
                }}
            >
                {children}
            </EtablissementAndPayBudgetContext.Provider>
        </OrgChartHrContext.Provider>
    );
};

export default HumanResourcesProvider;
